import axios from 'axios'
import * as types from '../mutation-types'

// State
export const state = {
  loading: false,
  userSettings: null,
  error: null,
}

// Mutations
export const mutations = {
  [types.GET_USER_SETTINGS_START] (state) {
    state.loading = true
    state.userSettings = null,
    state.error = null
  },

  [types.GET_USER_SETTINGS_SUCCESS] (state, data) {
    state.loading = false
    state.userSettings = data
    state.error = null
  },

  [types.GET_USER_SETTINGS_ERROR] (state, error) {
    state.loading = false
    state.userSettings = null
    state.error = error
  },

  [types.SET_USER_SETTINGS_START] (state) {
    state.loading = true
    state.userSettings = null
    state.error = null
  },

  [types.SET_USER_SETTINGS_SUCCESS] (state, data) {
    state.loading = false
    state.userSettings = data
    state.error = null
  },

  [types.SET_USER_SETTINGS_ERROR] (state, error) {
    state.loading = false
    state.userSettings = null
    state.error = error
  },
}

export const actions = {
  async getUserSettings ({ commit }, userId) {
    try {
      commit(types.GET_USER_SETTINGS_START)
      const { data } = await axios.get(`/api/user_settings/${userId}`)

      commit(types.GET_USER_SETTINGS_SUCCESS, data)
    } catch (error) {
      commit(types.GET_USER_SETTINGS_ERROR, error)
    }
  },

  async setExpandCostumerDetail ({ commit }, { userId, value }) {
    try {
      commit(types.SET_USER_SETTINGS_START)
      const { data } = await axios.post(`/api/user_settings/${userId}/expand_costumer_detail`, { value })

      commit(types.SET_USER_SETTINGS_SUCCESS, data)
    } catch (error) {
      commit(types.SET_USER_SETTINGS_ERROR, error)
    }
  },
  async setUpdateCoincidencesTableColumnsWidth({ commit }, { userId, value }) {
    try {
      commit(types.SET_USER_SETTINGS_START)
      const { data } = await axios.post(`/api/user_settings/${userId}/update_coincidences_columns_width`, { value })

      commit(types.SET_USER_SETTINGS_SUCCESS, data)
    } catch (error) {
      commit(types.SET_USER_SETTINGS_ERROR, error)
    }
  },
}

// Getters
export const getters = {
  loadingUserSettings: state => state.loading,
  userSettings: state => state.userSettings,
  errorUserSettings: state => state.error,
}
